module.exports = __webpack_public_path__ + "img/14@2x.2830c1cb.png";